import Result from './result';
import CancellableResult from './cancellableResult';

export default Result;

export { CancellableResult };
